import React from 'react';
import invariant from 'tiny-invariant';
import Globalize from '@sprinx/globalize';
export default function useChangeGlobalizeLocale() {
  return React.useCallback(function (supportedLocales, locale) {
    invariant(locale && supportedLocales.includes(locale), "Locale '".concat(locale, "' is empty or not supported. Supported locales are ").concat(supportedLocales.map(function (l) {
      return "'".concat(l, "'");
    }).join(', '))); // istanbul ignore next

    Globalize.locale(locale);
  }, []);
}